import React from 'react';
import DeleteModal from '../../../../../Components/Common/DeleteModal';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { toggleDeleteCampaignModal, toggleDeleteCreativeModal } from '../../../../../slices/modals/reducer';
import { removeCreative } from '../../../../../slices/campaigns/thunk';
import { setCreatives, setFilteredCreatives, setScrolledCreatives } from '../../../../../slices/campaigns/reducer';

function DeleteCreativeModal() {
  const dispatch = useDispatch();

  const selectModalState = createSelector(state => state, state => ({
    creatives: state.Campaign.creatives,
    filteredCreatives: state.Campaign.filteredCreatives,
    scrolledCreatives: state.Campaign.scrolledCreatives,
    deleteModal: state.Modal.deleteCreativeModal,
    deleteCreativeId: state.Campaign.deleteCreativeId,
  }));
  const { creatives, filteredCreatives, scrolledCreatives, deleteModal, deleteCreativeId } = useSelector(selectModalState);

  async function deleteCreative() {
    const isCreativeDeleted = await dispatch(removeCreative(deleteCreativeId));
    if (isCreativeDeleted) {
      const updatedCreatives = creatives.filter(creative => creative._id !== deleteCreativeId);
      const updatedFilteredCreatives = filteredCreatives.filter(creative => creative._id !== deleteCreativeId);
      const updatedScrolledCreatives = scrolledCreatives.filter(creative => creative._id !== deleteCreativeId);
      dispatch(setCreatives([]));
      dispatch(setFilteredCreatives([]));
      dispatch(setScrolledCreatives([]));
      setTimeout(() => {
        dispatch(setCreatives(updatedCreatives));
        dispatch(setFilteredCreatives(updatedFilteredCreatives));
        dispatch(setScrolledCreatives(updatedScrolledCreatives));
      }, 1);
    }
    dispatch(toggleDeleteCreativeModal());
  }

  return (
    <DeleteModal
      show={deleteModal}
      onCloseClick={() => { dispatch(toggleDeleteCreativeModal()) }}
      onDeleteClick={() => { deleteCreative() }}
    />
  )
}

export default DeleteCreativeModal
